import React from 'react'
import { useAssetManager } from 'components/AssetManager'
import { imgLoader } from 'common/services/imageLoader'
import photoIcon from '../../../../../i/photoIcon.svg'
import './ImageOrColorPicker.scss'

export const ImageOrColorPicker = ({ label, value, onUpdateImage, errorMessages = [] }) => {
    const { chooseAsset } = useAssetManager()
    const getBackground = () => {
        if (value.length === 7) {
            return { backgroundColor: value }
        } else {
            return { backgroundImage: `url(${imgLoader(value)})` }
        }
    }

    return (
        <div className="image-picker">
            {label.length ? <p className="image-picker__label">{label}</p> : null}
            <div className={`image-picker__area ${errorMessages.length ? 'is-error' : ''}`} style={getBackground()}>
                <img
                    className="image-picker__photo-icon"
                    src={photoIcon}
                    alt=""
                    onClick={() => chooseAsset(value, onUpdateImage)}
                />
            </div>
            {errorMessages.length
                ? errorMessages.map((message, i) => (
                      <p key={i} className="image-picker__error">
                          {message}
                      </p>
                  ))
                : null}
        </div>
    )
}
